import { AccountInterface } from 'starknet';
import { createAsyncAtom } from '../../lib/state';

const walletAccountAtom = createAsyncAtom<AccountInterface | null>(async () => null);

export default walletAccountAtom;
